export const mainnav = async (err) => {
  if (err) {
    console.error(err);
  }
  /*
   * Show mainmenu on menu click
   */
  const menuHamburger = document.getElementById('input__menu-toggle'),
    menuCloseBtn = document.getElementById('mainnav-close-btn');

  if (menuHamburger) {
    menuHamburger.addEventListener('click', () => {
      document.getElementsByTagName('html')[0].classList.toggle('nav-open');
      document
        .getElementsByClassName('nav-primary')[0]
        .classList.toggle('mainmenu--open');


    });
  }

  if (menuCloseBtn) {
    menuCloseBtn.addEventListener('click', () => {
      document.getElementsByTagName('html')[0].classList.toggle('nav-open');
      document
        .getElementsByClassName('nav-primary')[0]
        .classList.toggle('mainmenu--open');


    });
  }



  /*
   * Show sticky navigation on scroll up
   */
  var lastScrollTop, // This Varibale will store the top position
    //   navbar = document.getElementsByTagName('header')[0],
    navbarLogo = document.getElementsByClassName('brand')[0],
    navbarHamburger = document.getElementsByClassName('label-for-menu')[0];
  // navbarPrimary = document.getElementsByClassName('nav-primary')[0];

  window.addEventListener('scroll', function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 243) {
      //navbar.style.top = '-243px';

      // navbar.classList.add('navbar--sticky');

      if (scrollTop > lastScrollTop) {
        //if it will be greater than the previous
        //navbar.style.top = '-243px';
        navbarLogo.style.bottom = '0';
        navbarHamburger.style.bottom = '0';
      } else {
        /*         navbarLogo.style.bottom = '-243px';
                navbarHamburger.style.bottom = '-243px';
                navbarPrimary.style.paddingTop = '243px'; */
      }
    } else {
      /*       navbar.classList.remove('navbar--sticky');
            navbar.style.top = '0';
            navbarLogo.style.bottom = '0';
            navbarHamburger.style.bottom = '0';
            navbarPrimary.style.paddingTop = '0'; */
    }

    lastScrollTop = scrollTop; //New Position Stored
  });

};

import.meta.webpackHot?.accept(mainnav);
